<template>
	<span>
		<slot v-for="(item, index) in links" name="title">
			<b-nav-item
        :data-cy="getCypressDataCy(item.link)" 
        :key="index" 
        :to="item.link" 
        :title="item.description" 
        b-v-tooltip.hover
      >
				<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
				{{ item.name }}
			</b-nav-item>
		</slot>
	</span>
</template>
<script>

export default {
	name: "side-home-dynamic-group",
	computed: {
		links() {
		return this.$store.getters["getLinksByGroup"]('Home Group')
		},
		showNav() {
		return this.$store.getters["getLinksByGroup"]('Home Group').length > 0
		},
	},
	methods: {
		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
    getCypressDataCy(route) {
      let arr = route.split('/');
      let formattedRoute = arr[arr.length - 1];
      if (formattedRoute.includes(':')) {
        formattedRoute = arr[arr.length - 2];
      }
      // console.log(formattedRoute)
      return `side-home-${formattedRoute}`;
    },
	},
};
</script>
